import {Injectable}          from '@angular/core';
import {ApDateService}       from '../../../ap-core/services/ap-date-service';
import {CampaignYearService} from '../../../services/data/campaign-year.service';
import {MinMaxDateRange}     from '../../../types/common-types';
import ITimeSpan = System.ITimeSpan;

@Injectable()
export class FwEntryComponentsService {
  constructor(private dateService: ApDateService,
              private campaignYearService: CampaignYearService) {
  }

  /**
   * Gets the minimum and maximum date range for a plan book based on campaign year
   * @param campaignYear - The campaign year to get date range for
   * @returns MinMaxDateRange object containing Min and Max dates
   * Min date is June 1st of previous campaign year
   * Max date is December 31st 23:59:59.999 of campaign year
   * @public
   */
  public getMinAndMaxDateRangesForPlanBook(campaignYear: number): MinMaxDateRange {
    const campaignYearRange = this.campaignYearService.getCampaignYearRange(campaignYear);
    const fromDate = this.dateService.generateDate(1, 6, campaignYearRange.CampaignYear - 1);
    const toDate = this.dateService.generateDate(31, 11, campaignYearRange.CampaignYear,
      23, 59, 59, 999);
    return {
      Min: fromDate,
      Max: toDate
    };
  }

  /**
   * Converts ITimeSpan to a Date object with time components
   * @param timeSpan - TimeSpan object containing time information
   * @returns Date object with time set from timespan, or undefined if timespan is invalid
   * @public
   */
  public getTimeSpanInDate(timeSpan: ITimeSpan | undefined): Date | undefined {
    if (!timeSpan?.TotalMilliseconds) {
      return undefined;
    }
    return this.dateService.getDateWithTimeFromMilliseconds(timeSpan.TotalMilliseconds);
  }
}
